const FALLBACK_PUBLIC_URL = "https://sacafootball.com";

const isLocalHost = (value: string): boolean => {
    try {
        const parsed = new URL(value);
        const host = parsed.hostname.toLowerCase();
        return host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0" || host === "::1";
    } catch {
        return false;
    }
};

const normalizeUrl = (value: string | null | undefined): string | null => {
    if (!value || typeof value !== "string") return null;
    const trimmed = value.trim();
    if (!trimmed) return null;
    if (!/^https?:\/\//i.test(trimmed)) return null;
    return trimmed.replace(/\/+$/, "");
};

export const resolvePublicAppUrl = (): string => {
    const configured = normalizeUrl(process.env.REACT_APP_ENV_URL);
    const origin = normalizeUrl(globalThis.location?.origin);

    if (configured && !isLocalHost(configured)) {
        return configured;
    }

    if (origin && !isLocalHost(origin)) {
        return origin;
    }

    if (configured) {
        return configured;
    }

    if (origin) {
        return origin;
    }

    return FALLBACK_PUBLIC_URL;
};

